const initialState = {
  data:{},
  search:'',
  filter:{type:''},
  sort:{
    field:'sakh_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_SAKHS':
      return {
        ...state,
        data: action.payload
      }
    case 'SORT_SAKHS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_SAKHS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_SAKHS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_SAKH':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.sakh_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sakhs.js